import React, { useCallback, useContext, useEffect, useState } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import Paper from '@material-ui/core/Paper';
import { makeStyles } from "@material-ui/styles";
import * as actions from '../actions/actions';
import Service from "../services/service"
import CancelIcon from '@material-ui/icons/Cancel';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import { Link } from '@material-ui/core';
import FileUploadPanel from './FileUploadPanel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import UrlTextField from "./urlTextField";
import { config, resolveNotificationMessage } from '../helpers/constants';
import { ReactComponent as BooksIcon } from '../assets/icons/books.svg';
import FileCard from "./FileCard";
import LoadingScreen from '../components/LoadingScreen';


export default function TextFieldPanel(props) {

  const useStyles = makeStyles((theme) => ({
    root: {
      overflow: "hidden",
      flexDirection: "column",
      display: "flex",
      padding: theme.spacing(1),
      lineHeight: '18px',
      height: "100%"
    },

    paperHeader: {
      flex: "0 0 auto",
      padding: theme.spacing(1),
      fontSize: "1rem"
    },

    paperContent: {
      flex: "1 1 auto",
      borderBottom: "1px solid #dddddd",
      //padding: theme.spacing(1),
      position: "relative"
    },

    textarea: {
      background: "transparent",
      resize: "none",
      border: "0 none",
      width: "100%",
      outline: "none",
      height: "100%",  // textarea rounds up to next line height, so make sure not to display scroll bars if empty
      fontFamily: "inherit",
      fontSize: "inherit",
    },


    borderColor: {
      width: "100%",
      "& .MuiInput-underline:before": {
        borderBottom: "0px"
      },
      "& .MuiInput-underline:after": {
        borderBottom: "0px"
      },
      "& .MuiInput-underline:not(.Mui-disabled):before": {
        borderBottom: "0px"
      },
    },
    cancelButton: {
      textAlign: "end"
    },
    BorderRadius: {
      borderRadius: ""
    },
    textFieldSize: {
      width: "100%",
      display: "flex"
    },
    textPadding: {
      paddingTop: "5px",
      paddingBottom: "5px"
    },
    loader: {
      textAlign: "center",
      color: "white",
    },
    overlay: {
      zIndex: "99",
      display: "flex",
      justifyContent: "center",
      position: "relative",
      backgroundColor: "rgba(0,0,0,0.1)",
      height: "100%",
      width: "100%",
      alignItems: "center",
    },
    publicIconPadding: {
      paddingTop: "7px",
      paddingRight: "7px"
    },
    helpIconPadding: {
      paddingLeft: "7px",
      paddingTop: "7px"
    },
    rowAlign: {
      display: "flex"
    },
    table_library_header: {
      width: '20%',
      minWidth: "50px",
    },
    table_credits_header: {
      width: '60px',
      textAlign: "center",
      cursor: "default",
    },
    libraryName: {
      padding: '10px 5px',
      textAlign: 'left',
    },
    librarySource: {
      width: '20%',
      padding: '10px 5px',
      textAlign: 'left',
    },
    activitywords: {
      width: '85px',
      padding: '10px 5px',
      textAlign: 'left',
    },
    tableRow: {
      "&:hover": {
        backgroundColor: '#eeeeee ',
      },
      borderTop: '1px solid #D3D3D3',
      "&:last-child": {
        borderBottom: '1px solid #D3D3D3',
      },
      "&:nth-child(even)": {
        backgroundColor: '#f3f3f3',
        "&:hover": {
          backgroundColor: '#eeeeee ',
        },
      }
    },
    selectTextFromOtherSource: {
      margin: "auto",
      textAlign: "center",
      maxWidth: "46%",
    },
    infoIcon: {
      fontSize: "45px"
    }
  }))

  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);
  const [localText, setLocalText] = React.useState('');
  const [url, setUrl] = React.useState('');
  const [considerTags, setConsiderTags] = React.useState(true);
  const { source, text, textChanged } = props
  const [time, setTime] = React.useState({ typingTimeout: 0 });
  const [urlLoading, setUrlLoading] = React.useState(false);
  const expression = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/ig
  const regex = new RegExp(expression);


  useEffect(() => {
    if (text != localText) {
      setLocalText(text);
    }
  }, [text]);


  // set value of text field 
  const onTextChange = (value) => {
    if (value.length > config.textAllowed) {
      dispatch(actions.openToast({ type: "error", message: s.truncatedMessage, status: true }));
    }
    const truncatedValue = value.substring(0, config.textAllowed);
    setLocalText(truncatedValue);
    if (time.typingTimeout) {
      clearTimeout(time.typingTimeout);
    }
    let typingTime = setTimeout(function () {
      textChanged(truncatedValue);
    }, 500)
    setTime({ typingTimeout: typingTime })
  }

  // clear text field data 
  const clearTextField = () => {
    onTextChange('');
  }

  // set url in text field
  const onUrlFieldChange = (value) => {
    setUrl(value.trim());
  }

  // get text data from getUrlContent()
  const getTextFromUrl = () => {

    if (!url)
      return;

    onTextChange('');

    if (url.match(regex)) {
      setUrlLoading(true);
      Service.getUrlContents({ usetags: considerTags ? 1 : 0, url }).then(res => {
        setUrlLoading(false);
        if (res.data) {
          onTextChange(res.data.Text);
          if (res.data.Truncated) {
            dispatch(actions.openToast({ type: "error", message: s.truncatedMessage, status: true }));
          }
        }
        else {
          dispatch(actions.openToast({ type: "error", message: s.newCheck.urlReadError, status: true }));
        }
      });
    } else {
      dispatch(actions.openToast({ type: "error", message: s.invalidUrl, status: true }));
    }
  }


  // get data from getUrlContents on enter
  const getTextOnEnter = (event) => {
    if (event.key === "Enter") {
      document.getElementById("url").blur();
    }
  }

  //change tags checkbox value
  const tagsCheckboxClicked = (checked) => {
    setConsiderTags(checked);
  }


  const onDeleteLibraryText = useCallback((e, id) => {
    let remainingTexts = state.newCheckSettings.libraryTexts.filter(item => item.Id != id);
    dispatch(actions.setNewCheckSettings({ libraryTexts: remainingTexts }));
  });



  return (
    <Paper className={classes.root}>
      {source === 'upload' ? <FileUploadPanel /> :
        <>
          {source === "download" &&
            <div className={classes.paperHeader} style={{ borderBottom: "1px solid #dddddd" }}>
              <div className={classes.textFieldSize}>
                <UrlTextField onUrlFieldChange={onUrlFieldChange} getTextFromUrl={getTextFromUrl} urlFieldValue={url} getTextOnEnter={getTextOnEnter} />
              </div>
              <FormGroup style={{ width: "fit-content" }}>
                <FormControlLabel data-for="globalTT" data-tip={s.newCheck.considerPlagAwareTagsTip}
                  control={<Checkbox checked={considerTags} onChange={e => tagsCheckboxClicked(e.target.checked)} />}
                  label={s.newCheck.considerPlagAwareTags} />
              </FormGroup>
            </div>
          }
          <>
            {source === "library" ?
              <>
                {state.newCheckSettings.libraryTexts.length > 0 ?
                  <div style={{ width: "100%", minWidth: 0, minHeight: "100%", height: 0, overflow: "auto", display: "flex", flexWrap: "wrap", alignContent: "flex-start" }}>
                    {state.newCheckSettings.libraryTexts.map((item) => {
                      return (
                        <div style={{ width: "50%", padding: 8 }}>
                          <FileCard id={item.Id} title={item.Name} text1={s.newCheck.uploadFileWords.format(item.Words, item.Pages)} projectId={item.ProjectId} projectName={item.ProjectName} type="txt" onDelete={onDeleteLibraryText} progressValue={100} />
                        </div>
                      );
                    })}
                  </div>
                  :
                  <div className={classes.selectTextFromOtherSource}>
                    <BooksIcon onClick={() => dispatch(actions.navigate_to("/library/overview"))} fill="#0D4A81" height={100} width={100} style={{ cursor: "pointer", margin: 16 }} />
                    <p>
                      {s.newCheck.visitLibrary}
                    </p>
                    {s.common.goto} <Link href="#" onClick={() => dispatch(actions.navigate_to("/library/overview"))}>{s.library}</Link>
                  </div>
                }
              </>
              :
              <>
                <div className={classes.paperContent}>
                  <LoadingScreen status={urlLoading} noRadius text={s.newCheck.downloading} />
                  <textarea className={classes.textarea}
                    placeholder={source == "text" ? s.copyText : ""}
                    autoFocus={source == "text" ? true : false}
                    value={localText}
                    onChange={(evt) => { onTextChange(evt.target.value) }}>
                  </textarea>
                </div>
                <div className={classes.cancelButton}>
                  <IconButton onClick={clearTextField}>
                    <CancelIcon />
                  </IconButton>
                </div>
              </>
            }
          </>
        </>}
    </Paper>
  )
}